import { render, staticRenderFns } from "./InformationSecurityWidget.vue?vue&type=template&id=e20bd5cc&scoped=true&"
import script from "./InformationSecurityWidget.vue?vue&type=script&lang=ts&"
export * from "./InformationSecurityWidget.vue?vue&type=script&lang=ts&"
import style0 from "./InformationSecurityWidget.vue?vue&type=style&index=0&id=e20bd5cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20bd5cc",
  null
  
)

export default component.exports